class TaylorsHeader extends HTMLElement {
  constructor() {
    super();
    this.threshold = 40;
    this.sticky = this.dataset.enableSticky === 'true';
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    const trigger = this.querySelector('[data-mega-menu-trigger]');
    if (trigger) {
      trigger.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('mega-menu:open'));
      });
    }

    if (!this.sticky) return;
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const shouldStick = window.scrollY > this.threshold;
    this.classList.toggle('is-sticky', shouldStick);
  }
}

if (!customElements.get('taylors-header')) {
  customElements.define('taylors-header', TaylorsHeader);
}
